import { withFormik } from "formik"
import * as Yup from "yup"
import ApprovalsForm from "./form"

const validateRanges = (t: $TSMigrationFixMe, { rango }: $TSMigrationFixMe) => {
  let errors = { rango: {} }

  if (rango.operador === 6 && !rango.valorSuperior) {
    // @ts-expect-error TS(2339): Property 'valorSuperior' does not exist on type '{...
    errors.rango.valorSuperior = `${t("errors.enterValue")}`
  } else if (rango.operador === 6 && rango.valorSuperior) {
    if (rango.valorSuperior < rango.valorInferior) {
      // @ts-expect-error TS(2339): Property 'valorSuperior' does not exist on type '{...
      errors.rango.valorSuperior = `${t("errors.rangeSup")}`
    } else {
      // @ts-expect-error TS(2741): Property 'rango' is missing in type '{}' but requi...
      errors = {}
    }
  }

  // @ts-expect-error TS(2339): Property 'valorSuperior' does not exist on type '{...
  return errors.rango?.valorSuperior ? errors : {}
}

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    tipoDocumento: Yup.string().required(t("errors.selectedTypeDoc")),
    autovalidacion: Yup.boolean(),
    etapas: Yup.array()
      .of(
        Yup.object().shape({
          departamentoId: Yup.string(),
          departamentoNombre: Yup.string(),
          numeroFirmas: Yup.number(),
          orden: Yup.number(),
        })
      )
      .min(0)
      .when("autovalidacion", {
        is: false,
        then: Yup.array()
          .of(
            Yup.object().shape({
              departamentoId: Yup.string(),
              departamentoNombre: Yup.string(),
              numeroFirmas: Yup.number(),
              orden: Yup.number(),
            })
          )
          .min(1, t("errors.enterOneStage")),
        otherwise: Yup.array()
          .of(
            Yup.object().shape({
              departamentoId: Yup.string(),
              departamentoNombre: Yup.string(),
              numeroFirmas: Yup.number(),
              orden: Yup.number(),
            })
          )
          .min(0),
      }),

    rango: Yup.object()
      .shape({
        valorInferior: Yup.number(),
        valorSuperior: Yup.number(),
        operador: Yup.number(),
      })
      .when("todosLosRangos", {
        is: false,
        then: Yup.object().shape({
          valorInferior: Yup.number()
            .typeError(t("errors.numericValue"))
            .required(t("errors.enterValue")),
          valorSuperior: Yup.number()
            .typeError(t("errors.numericValue"))
            .nullable(),
          operador: Yup.number(),
        }),

        otherwise: Yup.object().shape({
          valorInferior: Yup.number().nullable(),
          valorSuperior: Yup.number().nullable(),
          operador: Yup.number().nullable(),
        }),
      }),
    todosLosRangos: Yup.boolean(),
  })

const NewApprovalForm = withFormik({
  // @ts-expect-error TS(2339): Property 't' does not exist on type '{}'.
  validate: (rowData, { t }) => validateRanges(t, rowData),
  validateOnChange: true,
  validateOnBlur: true,
  enableReinitialize: true,
  // @ts-expect-error TS(2339): Property 'flowData' does not exist on type '{}'.
  mapPropsToValues: ({ flowData }) => {
    return {
      tipoDocumento: flowData?.tipoDocumento || "",
      etapas: flowData?.etapas || [],
      rango: {
        operador: !Number.isNaN(flowData?.rango?.operador)
          ? flowData?.rango?.operador
          : "",
        valorInferior: flowData?.rango?.valorInferior || "",
        valorSuperior: flowData?.rango?.valorSuperior || null,
      },
      autovalidacion: flowData?.autovalidacion || false,
      todosLosRangos: flowData?.todosLosRangos || false,
      id: flowData?.id || "",
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),

  handleSubmit: async (values, { props }) => {
    values =
      values.rango.operador === 999
        ? (values = { ...values, rango: null })
        : values
    // @ts-expect-error TS(2339): Property 'sendRequest' does not exist on type 'obj...
    await props.sendRequest(values)
  },
})(ApprovalsForm)

export default NewApprovalForm
